module.exports = __webpack_public_path__ + "static/media/jadathebik.61ee5725.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/mp3/jadathebik.mp3
// module id = 29
// module chunks = 0